import type { StatusVariant } from '@/ui/StatusBadge';

import type { StatusMedicao } from '../tipos';

/** Mapeia o status da medição ao tom semântico e ao rótulo exibido no badge. */
export const STATUS_ATESTE: Record<StatusMedicao, { status: StatusVariant; label: string }> = {
  RASCUNHO: { status: 'rascunho', label: 'Rascunho' },
  PROCESSADA: { status: 'processado', label: 'Calculada' },
  APROVADA: { status: 'aprovado', label: 'Aprovada' },
  DEVOLVIDA: { status: 'rejeitado', label: 'Devolvida' },
};

const ROTULO_TIPO: Record<string, string> = {
  PF: 'PF',
  PJ: 'PJ',
  COOPERATIVA: 'Coop',
};

export function rotuloTipoPessoa(tipo: string): string {
  return ROTULO_TIPO[tipo] ?? tipo;
}

/** "dd/MM (seg)" — usado nas linhas de dia do drill-down. */
export function formatarDiaCurto(dataIso: string): string {
  const data = new Date(`${dataIso}T00:00:00`);
  const diaMes = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit' }).format(
    data,
  );
  const semana = new Intl.DateTimeFormat('pt-BR', { weekday: 'short' })
    .format(data)
    .replace('.', '');
  return `${diaMes} (${semana})`;
}

/** "dd/MM/yyyy" — usado no cabeçalho do drill-in de modalidades. */
export function formatarDataLonga(dataIso: string): string {
  const data = new Date(`${dataIso}T00:00:00`);
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(data);
}

/** "dd/MM HH:mm" — usado na coluna "Calculado em". */
export function formatarDataHora(dataIso: string): string {
  const data = new Date(dataIso);
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(data);
}

/** "01/2026" -> "Janeiro de 2026" — usado no seletor de mês de referência. */
export function formatarCompetencia(dataIso: string): string {
  const data = new Date(`${dataIso}T00:00:00`);
  const texto = new Intl.DateTimeFormat('pt-BR', { month: 'long', year: 'numeric' }).format(data);
  return texto.charAt(0).toUpperCase() + texto.slice(1);
}
